import {
  Box,
  Grid,
  Icon,
  Tabs,
  Stack,
  Heading,
  Text,
  Image,
  Flex,
  Theme,
} from "@chakra-ui/react";
import { ImageServiceCard } from "../components/custom/ServiceCard";
import { MdDraw } from "react-icons/md";
import { FaComputer } from "react-icons/fa6";
import { FaKeyboard } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const AllServicesScreen = () => {
  const services = [
    {
      category: "Cyber Cafe",
      icon: <FaComputer />,
      items: [
        {
          title: "New Voting Card",
          description:
            "Get help applying for a new voting card, making sure all details are filled out correctly for you.",
          image: "../assets/services/voting.png",
        },
        {
          title: "New Aadhar Card",
          description:
            "We assist with the full application process for a new Aadhar card, including filling out and verifying forms.",
          image: "../assets/services/aadhar.jpg",
        },
        {
          title: "New PAN Card",
          description:
            "Receive guidance for applying for a new PAN card, ensuring all information is correct and properly submitted.",
          image: "../assets/services/pan.jpg",
        },
        {
          title: "Railway Tickets",
          description:
            "Easily book railway tickets with our service, avoiding long online queues and saving you time.",
          image: "../assets/services/aadhar.jpg",
        },
        {
          title: "Driving License",
          description:
            "Get help applying for a new driving license or renewing an existing one, making the process smooth and simple.",
          image: "../assets/services/driving.jpg",
        },
        {
          title: "PVR Card",
          description:
            "Apply for or renew your PVR movie card quickly and easily for convenient movie access.",
          image: "../assets/services/pvc.jpg",
        },
        {
          title: "Digital to PVR Card",
          description:
            "Convert your digital IDs to PVR-compatible cards to make accessing PVR services easier.",
          image: "../assets/services/digital.jpg",
        },
        {
          title: "Resize Passport Size Photos",
          description:
            "Get your passport-size photos resized and formatted professionally for all official uses.",
          image: "../assets/services/passport.png",
        },
        {
          title: "Mobile and DTH Recharges",
          description:
            "Recharge your mobile phones and DTH services quickly and easily with our reliable recharges.",
          image: "../assets/services/recharge.png",
        },
      ],
    },
    {
      category: "Graphic Design",
      icon: <MdDraw />,
      items: [
        {
          title: "Logo Design",
          description:
            "Create a custom logo for your brand that looks professional and stands out from the rest.",
          image: "../assets/services/logo.jpg",
        },
        {
          title: "Business Card Design",
          description:
            "Get professionally designed business cards to make a great first impression for your business.",
          image: "../assets/services/business.jpg",
        },
        {
          title: "Flyer/Brochure Design",
          description:
            "Get attention with custom flyers and brochures, perfect for events and promotions.",
          image: "../assets/services/flyer.jpg",
        },
        {
          title: "Social Media Post Design",
          description:
            "Make your social media posts look great and attract more attention with custom designs.",
          image: "../assets/services/social.jpg",
        },
        {
          title: "Banner Design",
          description:
            "Get high-quality banners designed for both online and offline use, perfect for advertising your brand.",
          image: "../assets/services/banner.jpg",
        },
      ],
    },
    {
      category: "Typing",
      icon: <FaKeyboard />,
      items: [
        {
          title: "CV/Resume Creation",
          description:
            "Have a professional-looking CV or resume created to improve your chances in job applications.",
          image: "../assets/services/resume.jpg",
        },
        {
          title: "MS Word Document Formatting",
          description:
            "Get help formatting your MS Word documents to make them look clean and well-organized.",
          image: "../assets/services/word.jpg",
        },
        {
          title: "Marathi Typing and Translation",
          description:
            "We offer typing and translation services for Marathi, so you can have clear and accurate Marathi documents.",
          image: "../assets/services/marathi.png",
        },
      ],
    },
  ];

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>
          Services - Glory Online Cyber Cafe | Your 24/7 Digital Partner
        </title>
        <meta
          name="description"
          content="Explore Glory Online Cyber Cafe's services, including graphic design, typing, ID applications, and more. From voting cards to mobile recharges, we offer fast, reliable support for all your digital and documentation needs."
        />
        <link rel="canonical" href="https://www.gloryservices.work/services" />
      </Helmet>
      <Box
        bgImage='url("../assets/heroHome1.jpg")'
        height={{ base: "350px", md: "450px" }}
        w="full"
        backgroundSize="100% 100%"
        display="flex"
        alignItems="center"
      >
        <Flex px={{ base: "5", md: "10", lg: "20" }} gap={20}>
          <Stack gap={5} color="white">
            <Heading
              as="h2"
              size={{ base: "2xl", md: "4xl", lg: "5xl" }}
              letterSpacing="2px"
            >
              Work, Play, Create
              <br /> All in One Space
            </Heading>
            <Text fontSize={{ base: "sm", md: "md", lg: "lg" }}>
              Browse our range of cyber cafe services designed for creators,
              students, and professionals
            </Text>
          </Stack>

          <Image
            display={{ base: "none", md: "block" }}
            src="../assets/service.svg"
            alt="about"
            h={{ md: "150px", lg: "200px" }}
          />
        </Flex>
      </Box>

      <Box py={10} px={{ base: "5", md: "20", lg: "40" }} w="full">
        <Tabs.Root
          variant="enclosed"
          fitted
          lazyMount
          unmountOnExit
          defaultValue="0"
        >
          <Theme appearance="light">
            <Tabs.List bgColor="#fceeee">
              {services.map((category, index) => (
                <Tabs.Trigger
                  transition="all ease 0.2s"
                  key={index}
                  value={String(index)}
                  fontSize={{ base: "xs", md: "lg", lg: "xl" }}
                  // color="whiteAlpha.800"
                  // _selected={{
                  //   color: "white",
                  //   bg: "rgba(255,255,255,0.4)",
                  //   boxShadow: "rgba(0, 0, 0, 0.24) 0px 2px 3px;",
                  //   backdropFilter: "blur(10px)",
                  //   WebkitBackdropFilter: "blur(10px)",
                  // }}
                >
                  <Icon display={{ base: "none", md: "block" }}>
                    {category.icon}
                  </Icon>{" "}
                  {category.category}
                </Tabs.Trigger>
              ))}
            </Tabs.List>
          </Theme>

          {services.map((category, index) => (
            <Tabs.Content key={index} value={String(index)}>
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
                gap={{ base: "5", md: "5", lg: "10" }}
                justifyItems="center"
                my={5}
              >
                {category.items.map((item) => (
                  <ImageServiceCard
                    key={item.title}
                    src={item.image}
                    title={item.title}
                    desc={item.description}
                  />
                ))}
              </Grid>
            </Tabs.Content>
          ))}
        </Tabs.Root>
      </Box>
    </>
  );
};

export default AllServicesScreen;
